import { equalCols } from '../functions';

$(document).ready(function () {

	$(".new-auth-form .input-group").click(function () {
		$(".new-auth-form .input-group").removeClass("focus");
		$(this).addClass("focus");
	});

	$(".account-wrapper .open-menu-mobile").click(function () {
		$(".account-wrapper .left-menu").toggleClass("opened");
	});

	$(".dropdown").click(function () {
		$(this).toggleClass("open");
	});

	$(".menu-mobile .toggler-subcateg").click(function () {
		$(this)
			.find(".subcategorie-list")
			.slideToggle("opened");
		$(this).toggleClass("clicked");
	});

	$(".menuMobile-toggler").click(function () {
		$("header .menu-mobile").addClass("opened");
		$("body").addClass("overflow-hidden");
	});

	$(".close-menu-mobile").click(function () {
		$("header .menu-mobile").removeClass("opened");
		$("body").removeClass("overflow-hidden");
	});

	if ($(".boxes-carousel.multiple-items").length > 0) {
		$(".boxes-carousel.multiple-items").slick({
			dots: true,
			infinite: true,
			speed: 300,
			slidesToShow: 4,
			slidesToScroll: 1,
			arrows: true,
			responsive: [
				{
					breakpoint: 1025,
					settings: {
						slidesToShow: 3,
						slidesToScroll: 1,
						infinite: true,
						dots: true,
					},
				},
				{
					breakpoint: 769,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 1,
					},
				},
				{
					breakpoint: 481,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1,
						arrows: false,
						centerMode: true,
						centerPadding: "40px",
					},
				},
				// You can unslick at a given breakpoint now by adding:
				// settings: "unslick"
				// instead of a settings object
			],
		});
	}

	$(".accordion .question").click(function () {
		$(this).toggleClass("clicked");
	});

	// const swiperOffers = new Swiper('.swiper-offers', {
	//   // Optional parameters
	//   allowTouchMove: true,
	//   loop: true,
	//   slidesPerView: 3,
	//   spaceBetween: '30',
	//   grabCursor: true,

	// });

	if ($('.swiper-offers').length > 0) {
		const swiper = new Swiper(".swiper-offers", {
			// Optional parameters
			// direction: 'vertical',
			slidesPerView: 1,
			loop: true,
			spaceBetween: 30,

			breakpoints: {
				768: {
					slidesPerView: 2,
					spaceBetween: 30,
				},
				992: {
					slidesPerView: 3,
					spaceBetween: 30,
				},
			},
		});
	}

	if ($('.swiper-products').length > 0) {
		const swiperProducts = new Swiper('.swiper-products', {
			// Optional parameters
			// direction: 'vertical',
			// loop: true,
			slidesPerView: 1,
			spaceBetween: 30,

			// If we need pagination
			pagination: {
				el: '.swiper-pagination',
			},

			// Navigation arrows
			navigation: {
				nextEl: '.products-next',
				prevEl: '.products-prev',
			},
			breakpoints: {
				768: {
					slidesPerView: 2,
					spaceBetween: 30,
				},
				992: {
					slidesPerView: 3,
					spaceBetween: 70,
				},
			},
		});
	}

	if ($('.swiper-filter').length > 0) {
		const swiperFilter = new Swiper('.swiper-filter', {
			// Optional parameters
			// direction: 'vertical',
			// loop: true,
			slidesPerView: 3,
			spaceBetween: 10,

			// If we need pagination
			pagination: {
				el: '.swiper-pagination',
				clickable: true,
			},

			breakpoints: {
				768: {
					slidesPerView: 7,
					spaceBetween: 10,
				},
				992: {
					slidesPerView: 7,
					spaceBetween: 10,
				},
			},
		});
	}

	if ($('.swiper-listing').length > 0) {
		const swiperListing = new Swiper('.swiper-listing', {
			// Optional parameters
			// direction: 'vertical',
			slidesPerView: 1,
			loop: true,

			// If we need pagination
			pagination: {
				el: '.swiper-pagination',
				clickable: true,
			},

			// Navigation (săgeți)
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev',
			},
		});
	}

	$(".select2").select2();

	/* It's a way to initialize all tooltips on the page. */
	const tooltipTriggerList = document.querySelectorAll(
		'[data-bs-toggle="tooltip"]'
	);
	/* An empty data-bs-title/title is normalized to null by Bootstrap and makes
	   the constructor throw, which would abort the rest of this ready handler. */
	const tooltipList = [...tooltipTriggerList]
		.filter(
			(tooltipTriggerEl) =>
				(
					tooltipTriggerEl.getAttribute('data-bs-title') ||
					tooltipTriggerEl.getAttribute('title') ||
					''
				).trim() !== ''
		)
		.map((tooltipTriggerEl) => new bootstrap.Tooltip(tooltipTriggerEl));

	$(".filter-btn").click(function (e) {
		e.preventDefault();
		const elementBox = $(this).parents('.section-header').siblings('.section-content');
		$(this).toggleClass("active");
		$(elementBox).slideToggle();
	});

	$(document).on('click', '.summary-show-search-form-btn', function () {
		$(".filter-btn").trigger('click');
		$('#modal-summary').modal('hide');
	});

	$(".date-picker").datepicker({
		autoclose: true,
		format: 'dd/mm/yyyy'
	});

	var header = $("header");
	var headerExtra = $(".top-bar-header");
	var scrollChange = 150;
	$(window).scroll(function () {
		var scroll = $(window).scrollTop();
		if (scroll >= scrollChange) {
			header.addClass('active');
			if ($(window).width() > 768) {
				headerExtra.slideUp();
			}
		} else if (scroll == 0) {
			header.removeClass("active");
			if ($(window).width() > 768) {
				headerExtra.slideDown();
			}
		}
	});

	equalCols('.same-height-div');
});

$('.testimonials-slider').slick({
	slidesToShow: 3,
	slidesToScroll: 1,
	dots: false,
	arrows: true,
	responsive: [
		{
			breakpoint: 1024,
			settings: {
				slidesToShow: 2
			}
		},
		{
			breakpoint: 767,
			settings: {
				slidesToShow: 1,
				dots: true,
				arrows: false,
				centerMode: true,
				centerPadding: '40px'
			}
		}
	]
});


// WEBPACK FOOTER //
// ./resources/assets/js/regular/general.js